import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  props: {},
  mounted() {
    if (this.$route.query === undefined || this.$route.query === null || this.$route.query.rep === undefined || this.$route.query.rep === null) {
      return this.$router.push('/');
    }
  }
})

export default class TechBetterCorpCoZaBlockPage extends Vue {
}
